var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictos",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #1d1d1b;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m34.54,28.99l11.48-11.48c.55-.55.16-1.49-.62-1.49h-26.8c-.78,0-1.17.94-.62,1.49l11.48,11.48c.97.97,1.51,2.28,1.51,3.65v12.65c0,.63-.45,1.16-1.07,1.26l-5.91,1.01v.41h16.02v-.41l-5.91-1.01c-.62-.11-1.07-.64-1.07-1.26v-12.65c0-1.37.54-2.68,1.51-3.65Zm-.58-4.2c-.47,0-.86-.38-.86-.86s.38-.86.86-.86.86.38.86.86-.38.86-.86.86Zm3.4-2.57c-.47,0-.86-.38-.86-.86s.38-.86.86-.86.86.38.86.86-.38.86-.86.86Zm-8.99,1.71c-.47,0-.86-.38-.86-.86s.38-.86.86-.86.86.38.86.86-.38.86-.86.86Zm2.77-2.57c-.47,0-.86-.38-.86-.86s.38-.86.86-.86.86.38.86.86-.38.86-.86.86Zm-10.06-2.4c-.18,0-.32-.14-.32-.32s.14-.32.32-.32h22.01c.18,0,.32.14.32.32s-.14.32-.32.32h-22.01Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoBar);
export default __webpack_public_path__ + "static/media/picto-bar.b07f25ed23a72411c4618c7da13aeda8.svg";
export { ForwardRef as ReactComponent };